import React from "react";

function Settings() {
  return (
    <div style={{ padding: "20px" }}>
      <h2>Settings</h2>
      <p>Settings panel coming soon...</p>
    </div>
  );
}

export default Settings;